import React, { useEffect, useState } from 'react';
import usePriceSuggestion from './usePriceSuggestion';
import quoteService from 'modules/emergencies/quoteService';
import PriceDisplay from 'modules/emergencies/components/ui/price-display/PriceDisplay';
import { SemaphoreInputComponent } from '@ontruck/fe-ui';

export const PriceSuggestionDynamic = ({ quoteFormBodyData }) => {
  const { ticketDetail, values, setFieldValue } = quoteFormBodyData;

  const ticket_id = ticketDetail.id;

  const [lastPriceSuggestionDTOString, setLastPriceSuggestionDTOString] = useState(null);

  const { isLoadingPriceSuggestion, priceSuggestion, priceSuggestionError } = usePriceSuggestion({
    ticket_id,
    priceSuggestionDTOString: lastPriceSuggestionDTOString,
  });

  const priceSuggestionDTO = quoteService.dataTransformation.getPriceSuggestionDTO({
    ticketDetail,
    values,
  });

  const priceSuggestionDTOString = JSON.stringify(priceSuggestionDTO);
  if (priceSuggestionDTO !== null && priceSuggestionDTOString !== lastPriceSuggestionDTOString)
    setLastPriceSuggestionDTOString(priceSuggestionDTOString);

  useEffect(() => {
    if (priceSuggestion !== undefined) {
      setFieldValue('suggested_price.amount', priceSuggestion.price.amount);
      setFieldValue('suggested_price.currency', priceSuggestion.price.currency);
      setFieldValue('price_suggestion_id', priceSuggestion.id);
    }
  }, [priceSuggestion, setFieldValue]);

  let amounthWithNodecimals = priceSuggestion?.price?.amount;
  let level = priceSuggestion?.classification;

  try {
    if (amounthWithNodecimals) {
      amounthWithNodecimals = `€ ${Math.trunc(priceSuggestion.price.amount)}`;
    } else {
      amounthWithNodecimals = `N/A`;
    }
  } catch (e) {
    amounthWithNodecimals = `N/A`;
  }
  return (
    <>
      {level && level !== '' ? (
        <SemaphoreInputComponent
          label="AI Suggested Pricing"
          value={amounthWithNodecimals}
          level={level}
          hasErrors={priceSuggestionError}
          isLoading={isLoadingPriceSuggestion}
          isReadonly={true}
        />
      ) : (
        <PriceDisplay
          label={<>Suggested price</>}
          isReadonly={false}
          hasError={priceSuggestionError}
          errorMsg={'It has not been possible to estimate the price'}
          isLoading={isLoadingPriceSuggestion}
          price={typeof priceSuggestion?.price?.amount !== 'undefined' && amounthWithNodecimals}
        />
      )}
    </>
  );
};
